import { render, staticRenderFns } from "./LPLanguageSwitcher.vue?vue&type=template&id=6ac046ee&scoped=true"
import script from "./LPLanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LPLanguageSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LPLanguageSwitcher.vue?vue&type=style&index=0&id=6ac046ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac046ee",
  null
  
)

export default component.exports